import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingGuard implements CanActivate {
  private router = inject(Router);

  canActivate(): Observable<boolean> {
    const isDataLoaded = true;

    if (!isDataLoaded) {
      this.router.navigate(['/app/dashboard']);
      return of(false);
    }

    return of(true);
  }
}
